
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCGVpidiSpFKfQa4sbGpnyYgAdy__iukUE",
  authDomain: "feistydex.firebaseapp.com",
  projectId: "feistydex",
  storageBucket: "feistydex.firebasestorage.app",
  messagingSenderId: "5561923604",
  appId: "1:5561923604:web:36fa65df7befa3b7da4f01",
  measurementId: "G-Q0P0427BN9"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Configurações do Google Provider
googleProvider.setCustomParameters({
  prompt: 'select_account',
  display: 'popup'
});
